import { IntegrationPartner } from '@centric-os/types';

const ThriveBoostIntegrationTypes = [
  IntegrationPartner.BOOST.toLowerCase(),
  IntegrationPartner.THRIVE.toLowerCase(),
];

/**
 * Returns true when integrationType maps to thrive/boost.
 */
export const isThriveOrBoostIntegrationType = (integrationType?: string | null): boolean => {
  const type = String(integrationType ?? '').toLowerCase();
  return ThriveBoostIntegrationTypes.includes(type);
};
